<div
  class="settings-page"
  [class.panel-open]="!isLoading && accountPanelOpen"
  [class.panel-collapsed]="!isLoading && !accountPanelOpen"
>
  <div class="settings-shell">
    <header class="settings-header">
      <div class="settings-header__intro">
        <p class="settings-header__eyebrow" *ngIf="settingsData?.organization?.name">
          {{ settingsData.organization.name }}
        </p>
        <h1 class="settings-header__title">Settings</h1>
        <p class="settings-header__subtitle">
          Manage your organization’s team, locations and access.
        </p>
      </div>

      <div
        class="settings-alert"
        *ngIf="!settingsData?.paymentInfo && !isLoading"
        role="alert"
      >
        <i class="material-icons settings-alert__icon">credit_card</i>
        <div class="settings-alert__body">
          <p class="settings-alert__title">Payment information missing</p>
          <p class="settings-alert__text">
            Add a payment method so your subscription stays active.
          </p>
        </div>
        <button
          mat-flat-button
          color="primary"
          class="settings-alert__action"
          (click)="openSubscriptionPaymentModal()"
        >
          Update payment info
        </button>
      </div>

      <nav class="settings-tabs" aria-label="Settings sections">
        <a
          class="settings-tab"
          routerLink="/settings/team"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">group</i>
          <span>Team</span>
        </a>
        <a
          class="settings-tab"
          routerLink="/settings/locations"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">place</i>
          <span>Locations</span>
        </a>
        <a
          class="settings-tab"
          routerLink="/settings/invoices"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">receipt_long</i>
          <span>Invoices</span>
        </a>
        <a
          class="settings-tab"
          *ngIf="isSuperAdmin"
          routerLink="/settings/history"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">payments</i>
          <span>Payment history</span>
        </a>
        <a
          class="settings-tab"
          *ngIf="isSuperAdmin"
          routerLink="/settings/email-tester"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">mark_email_read</i>
          <span>Email tester</span>
        </a>
        <a
          class="settings-tab"
          *ngIf="isSuperAdmin"
          routerLink="/settings/push-notifications"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">notifications</i>
          <span>Notifications</span>
        </a>
        <a
          class="settings-tab"
          routerLink="/settings/whitelist"
          [routerLinkActive]="['is-active']"
        >
          <i class="material-icons">lan</i>
          <span>Whitelist</span>
        </a>
      </nav>
    </header>

    <div class="settings-loading" *ngIf="isLoading">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <div class="settings-body" *ngIf="!isLoading">
      <router-outlet></router-outlet>
    </div>
  </div>

  <aside
    class="account-panel"
    *ngIf="!isLoading"
    [class.collapsed]="!accountPanelOpen"
    aria-label="Account menu"
  >
    <button
      type="button"
      class="account-panel-toggle"
      (click)="toggleAccountPanel()"
      [attr.aria-expanded]="accountPanelOpen"
      [title]="
        accountPanelOpen ? 'Collapse account menu' : 'Expand account menu'
      "
    >
      <i class="material-icons">{{
        accountPanelOpen ? "chevron_right" : "chevron_left"
      }}</i>
      <span class="account-panel-toggle-label">Account</span>
    </button>

    <div class="account-panel-body">
      <app-generic-account-card
        [settingsData]="settingsData"
        [isLoading]="isLoading"
        [paymentData]="paymentData"
      ></app-generic-account-card>
    </div>
  </aside>
</div>
